import { Component, OnInit } from '@angular/core';
import { GlobalVariable } from '../../config/variable';

@Component({
    selector: 'app-authentication-aborted',
    template: `
        <div class="auth-info">
            <div *ngIf='!globalVariable?.authenticationStatus?.policy'>
                <img src="assets/icon/info_warning.png">
                <p>{{globalVariable?.authenticationStatus?.message}}</p>
            </div>
            <div *ngIf='globalVariable?.authenticationStatus?.policy'>
                <img src="assets/icon/policity.png">
            </div>
        </div>
    `,
    styleUrls: ['./authentication-aborted.component.scss'],
    standalone: false
})
export class AuthenticationAbortedComponent implements OnInit {
  globalVariable = GlobalVariable;

  constructor() {
  }

  ngOnInit() {
  }

}
